import { render, staticRenderFns } from "./editEnforceabilityScore.vue?vue&type=template&id=29c6f132"
import script from "./editEnforceabilityScore.vue?vue&type=script&lang=js"
export * from "./editEnforceabilityScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports